'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseAxisController=require('../../../../dist-es6/client/directives/plotting/baseAxisController');
const BaseAxisDirective=require('../../../../dist-es6/client/directives/plotting/baseAxisDirective');let

ShiftedLinearAxisController=class ShiftedLinearAxisController extends BaseAxisController{
constructor($scope){
super($scope);
}

get _scaleCreator(){
return d3.scale.linear();
}

set lengthOnScreen(newLength){
if(newLength===this._lengthOnScreen){
return;
}
this._lengthOnScreen=newLength;

switch(this.orientation){
case'horizontal':
this._range={start:this.plotArea.graphAreaBoundaries.left+this.offset,end:this.plotArea.dimensions.width};
break;
case'vertical':
this._range={start:this.plotArea.dimensions.height,end:this.plotArea.graphAreaBoundaries.top+this.offset};
break;}


this._updateScale();
}};let


ShiftedLinearAxisDirective=class ShiftedLinearAxisDirective extends BaseAxisDirective{
get controller(){return ShiftedLinearAxisController}};


module.exports=ShiftedLinearAxisDirective;
//# sourceMappingURL=shiftedLinearAxisDirective.js.map
